import * as queries from '@queries/utils';

export const fetchClients = () => queries.getQuery('/api/clients', 'populate=contacts,sales_items.idChantier,chantiers');

export const createClients = (clients) => queries.postQuery('/api/clients', clients);

export const updateClients = (clients) => queries.putQuery(`/api/clients`, clients);

export const deleteClients = (clientsToDelete) => queries.deleteQuery(`/api/clients`, clientsToDelete);